import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';

import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

import { useAuth } from 'context/auth';

// Register the required components
echarts.use(
  [GaugeChart, CanvasRenderer]
);

function Gauge(props) {

  const { themeSettings } = useAuth();

  const option = {
    series: [
      {
        type: 'gauge',
        center: ['50%', '66%'],
        startAngle: 180,
        endAngle: 0,
        title: {
          color: themeSettings.mode === 'dark' ? '#FFF' : '#464646',
        },
        itemStyle: {
          color: '#6365F1'
        },
        detail: {
          formatter: '{value} %',
          offsetCenter: [0, '-25%'],
          fontSize: 16,
        },
        progress: {
          show: true,
          width: 8
        },
        pointer: {
          show: false
        },
        axisLine: {
          lineStyle: {
            width: 8,
            color: [
              [1, '#EAEAFD']
            ]
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        radius: "100%",
        data: [
          {
            detail: {
              color: themeSettings.mode === 'dark' ? '#FFF' : '#464646',
            },
            value: props.value ? props.value.toFixed(2) : 0,
            name: props.label
          }
        ]
      }
    ]
  };

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={option}
      loadingOption={{ color: '#6365F1', text: '' }}
      showLoading={props.value === undefined}
      style={{ height: '100%', width: '100%' }}
    />
  );
}

export default Gauge;